export default {
  HANDLE_SUCCESS_GET_USER_PROFILE: 'handleSuccessGetUserProfile',
};



// WEBPACK FOOTER //
// ./src/app/main/user-profile/constants/action-types.js